<div class="{{ size }} wrapper">
  <button type="button" class="down" (click)="decrement()" [disabled]="disabled" tabindex="-1">
    <cx-icon type="MINUS"></cx-icon>
  </button>
  <input
    [formControl]="quantityControl"
    sdOnlyNumber="float"
    type="number"
    [min]="min"
    [max]="max"
    [step]="step"
    [readonly]="readonly"
    [tabindex]="readonly ? -1 : 0"
    [ngClass]="{ withLabel: !!unitName }"
    (keydown.enter)="onEnterPress()"
    (blur)="onBlur()"
    (focus)="onFocus()"
    enterkeyhint="done"
    #quantityInput
  />

  <span *ngIf="unitName" class="label">
    <cx-spinner *ngIf="loading; else loaded"></cx-spinner>
    <ng-template #loaded>
      {{ value | formattedNumber: '1.0-3' }} {{ unitName }}
      <span *ngIf="showSaleUnit">&nbsp;({{ saleQuantity }} {{ saleUnit.name }})</span>
    </ng-template>
  </span>

  <button
    #buttonUp
    type="button"
    class="up"
    (click)="increment()"
    [disabled]="disabled || (valueExceeded$ | async)"
    [title]="buttonUp.disabled ? 'Отсутствует остаток на складе' : ''"
    tabindex="-1"
  >
    <cx-icon type="PLUS"></cx-icon>
  </button>
</div>

<div class="error" *ngIf="valueExceeded$ | async">Это все, что у нас есть сейчас на складе</div>
